import "../../App.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import TextField from "@mui/material/TextField";

export default function DoctorProfileSettings() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [degreeCertificateUrl, setDegreeCertificateUrl] = useState("");
  const [degreeCertificateFile, setDegreeCertificateFile] = useState(null);
  const [form, setForm] = useState({
    Name: "",
    Title: "",
    Degree: "",
    MobileNo: "",
    Adress: "",
  });

  useEffect(() => {
    fetch(window.API_PREFIX + "admin/doctordetail", {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify({ Token: localStorage.getItem("DToken") }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data?.status === "Block") {
          toast.error(data?.message || "Unauthorized");
          localStorage.clear();
          navigate("/doctor");
          window.location.reload();
        } else if (data?.status === "1") {
          setForm({
            Name: (data.data?.Name || "").replace(/^\s+|\s+$/g, ""),
            Title: data.data?.Title || "",
            Degree: data.data?.Degree || "",
            MobileNo: data.data?.DocNo || "",
            Adress: data.data?.Address || "",
          });
          setDegreeCertificateUrl(
            data.data?.DegreeCertificateUrl || data.data?.DegreeCertificate || "",
          );
          setDegreeCertificateFile(null);
        }
      });
  }, []);

  return (
    <div className="container-fuild mx-2 mt-2">
      <div className="p-3" style={{ border: "1px solid #eee", borderRadius: 12 }}>
        <h4 className="mb-3">Profile Settings</h4>

        <div className="row">
          <div className="col-md-6">
            <TextField
              fullWidth
              label="Name"
              value={form.Name}
              onChange={(e) => setForm((p) => ({ ...p, Name: e.target.value }))}
            />
          </div>
          <div className="col-md-6">
            <TextField
              fullWidth
              label="Title"
              value={form.Title}
              onChange={(e) => setForm((p) => ({ ...p, Title: e.target.value }))}
            />
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-md-6">
            <TextField
              fullWidth
              label="Degree"
              value={form.Degree}
              onChange={(e) => setForm((p) => ({ ...p, Degree: e.target.value }))}
            />
          </div>
          <div className="col-md-6">
            <TextField
              fullWidth
              label="Mobile"
              value={form.MobileNo}
              onChange={(e) => setForm((p) => ({ ...p, MobileNo: e.target.value }))}
            />
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-12">
            <TextField
              fullWidth
              label="Address"
              value={form.Adress}
              onChange={(e) => setForm((p) => ({ ...p, Adress: e.target.value }))}
            />
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-12">
            <label className="form-label fw-semibold">Degree certificate (PDF or image)</label>
            {degreeCertificateUrl ? (
              <div className="mb-2">
                <a
                  href={degreeCertificateUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="small"
                >
                  View current certificate
                </a>
              </div>
            ) : null}
            <input
              type="file"
              className="form-control"
              accept=".pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/*"
              onChange={(e) =>
                setDegreeCertificateFile(e.target.files?.[0] || null)
              }
            />
            <div className="form-text">
              Upload a new file to replace the stored certificate on save.
            </div>
          </div>
        </div>

        <button
          className="btn btn-dark mt-3"
          disabled={loading}
          onClick={() => {
            setLoading(true);
            fetch(window.API_PREFIX + "admin/update_doctor_profile", {
              method: "POST",
              body: (() => {
                const fd = new FormData();
                fd.append("Token", localStorage.getItem("DToken"));
                fd.append("Name", form.Name);
                fd.append("Title", form.Title);
                fd.append("Degree", form.Degree);
                fd.append("MobileNo", form.MobileNo);
                fd.append("Adress", form.Adress);
                if (degreeCertificateFile) {
                  fd.append("doctorDegreeCertificate", degreeCertificateFile);
                }
                return fd;
              })(),
            })
              .then((r) => r.json())
              .then((data) => {
                if (data?.status === "1") {
                  toast.success("Profile updated");
                  setDegreeCertificateFile(null);
                  fetch(window.API_PREFIX + "admin/doctordetail", {
                    method: "POST",
                    headers: { "Content-type": "application/json" },
                    body: JSON.stringify({
                      Token: localStorage.getItem("DToken"),
                    }),
                  })
                    .then((r) => r.json())
                    .then((d2) => {
                      if (d2?.status === "1") {
                        setDegreeCertificateUrl(
                          d2.data?.DegreeCertificateUrl ||
                            d2.data?.DegreeCertificate ||
                            "",
                        );
                      }
                    });
                } else toast.error(data?.message || "Update failed");
              })
              .catch(() => toast.error("Update failed"))
              .finally(() => setLoading(false));
          }}
        >
          {loading ? "Saving..." : "Save Changes"}
        </button>
      </div>
    </div>
  );
}

